import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import { API_URL } from "../../constants";
import { getBanner, getPages, getGeneral } from "../../actions/modules_action/customizations";
import EduSpinner from "./EduSpinner";

class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bannerImage: "",
      accessId: 1,
      pages: [],
      logo_image: '',
      loadingBanner: true,
      loadingPages: true,
      loadingGeneral: true,
      formErrorMessage: '',
    };
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.props.getBanner(this.props.token, this.state.accessId);
    this.props.getGeneral(this.props.token, this.state.accessId);
    this.props.getPages(this.props.token, this.state.accessId);

    setTimeout(
      () =>
        window.scrollTo({
          behavior: "smooth",
          top: this.myRef.current.offsetTop
        }),
      2000
    );
  }

  componentDidUpdate(prevProps) {
    // Banner
    if (this.props.GetBanner !== prevProps.GetBanner &&
      Object.keys(this.props.GetBanner).length > 0 &&
      "status" in this.props.GetBanner
    ) {
      if (
        this.props.GetBanner.status &&
        Object.keys(this.props.GetBanner.data).length > 0
      ) {
        if (this.props.GetBanner.data.imageUrl !== undefined) {
          this.setState({
            bannerImage: this.props.GetBanner.data.imageUrl,
            loadingBanner: false,
          });
        }
      }
    }
    // Pages
    if (this.props.GetPages !== prevProps.GetPages &&
      Object.keys(this.props.GetPages).length > 0 &&
      "status" in this.props.GetPages
    ) {
      if (
        this.props.GetPages.status &&
        Object.keys(this.props.GetPages.data).length > 0
      ) {
        let pages = this.props.GetPages.data;
        let newPages = [];
        for (let key in pages) {
          newPages[pages[key].slug] = pages[key].content;
        }
        this.setState({
          pages: newPages,
          loadingPages: false,
        });
      } else {
        this.setState({
          formErrorMessage: "Something Wrong.",
          loadingPages: false,
        });
      }
    }
    // General
    if (this.props.GetGeneral !== prevProps.GetGeneral &&
      Object.keys(this.props.GetGeneral).length > 0 &&
      "status" in this.props.GetGeneral
    ) {
      if (
        this.props.GetGeneral.status &&
        Object.keys(this.props.GetGeneral.data).length > 0
      ) {
        this.setState({
          logo_image: this.props.GetGeneral.data.logo_image,
          loadingGeneral: false,
        });
      }
    }
  }

  componentWillUnmount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  }

  render() {
    const isLoading = this.state.loadingBanner || this.state.loadingPages || this.state.loadingGeneral;
    const htmlString =
      this.state.pages['home_image_content']
        ? this.state.pages['home_image_content']
        : 'The FlightScope University has been established to provide a forum to educate our FlightScope customers and golf professionals around the world....';

    return (
      <div className="banner" ref={this.myRef}>
        {/* Stylish course/student spinner CSS */}
        {isLoading ? (
         <EduSpinner />
        ) : (
          <>
            <img
              src={`${API_URL}/${this.state.logo_image}`}
              alt="The Last of us"
              className="img-fluid"
            />
            <Container className="top-content col-sm-10 auto-margin banner-text">
              <div className="display-4 mb-5 pt-4 text-center">
                <span className="flight-size headingtop img-content">
                  {this.state.pages['home_image_content'] && this.state.pages['home_image_content'] !== null
                    ? <div dangerouslySetInnerHTML={{ __html: this.state.pages['home_image_content'] }} />
                    : 'The FlightScope University has been established to provide a forum to educate our FlightScope customers and golf professionals around the world....'}
                </span>
              </div>
              <div className="row pd-t-20">
                <div className="d-flex justify-content-space-bitween col">
                  <a href="/#/login" className="btn btn-info btn-auto">
                    Login
                  </a>
                  <a href="/#/signup" className="btn btn-info btn-auto">
                    Sign Up
                  </a>
                </div>
              </div>
              {this.state.formErrorMessage && (
                <div className="alert alert-danger mt-3">{this.state.formErrorMessage}</div>
              )}
            </Container>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    GetBanner: state.GetBanner,
    GetPages: state.GetPages,
    GetGeneral: state.GetGeneral,
  };
};

export default connect(
  mapStateToProps,
  { getBanner, getPages, getGeneral }
)(Slider);